import { useEffect, useState, useRef } from "react";
import { SOCKET_URL } from "utils/constants";

import PageHeader from "components/PageHeader";
import Filter from "./components/Filter";
import { RfqTable } from "pages/DashboardList/components/Table/RfqTable";
import { FilterIcon } from "components/assets/Icons";

import styles from "./DashboardList.module.scss";

const DashboardList = () => {
  const [currentScreen] = useState({
    screen: "List",
    title: "Requests List",
  });
  const [open, setOpen] = useState(false);

  const [socket, setSocket] = useState(null); // Store the WebSocket connection
  const [data, setData] = useState(null); // Store received data
  const [loading, setLoading] = useState(false)
  const connect = () => {
    const token = JSON.parse(localStorage.getItem("token"));
    const socket_URL = SOCKET_URL + "/ws/rfq_list/?token=" + (token ? token.auth_token : null);
    
    const ws = new WebSocket(socket_URL);
    setLoading(true)

    ws.onmessage = (event) => {
      try {
        const receivedData = JSON.parse(event.data); // Parse JSON data
        setData(receivedData); // Store received data in state
        setLoading(false)
      } catch (err) {
        console.error("Error parsing WebSocket data:", err);
      }
    };

    ws.onerror = (error) => {
      console.error("WebSocket error:", error);
      setLoading(false)
    };

    setSocket(ws);
  };

  // Clean up WebSocket connection on unmount
  useEffect(() => {
    return () => {
      if (socket) {
        socket.close();
      }
    };
  }, [socket]);

  useEffect(() => {
    connect();
  }, []);

  const filterRef = useRef(null);

  const handleClearAll = () => {
    // Call the method on the Filter component to clear all its states
    if (filterRef.current) {
      filterRef.current.clearAllStates();
    }
  };
  const handleUseFilters = () => {
    if (filterRef.current) {
      const filterValues = filterRef.current.getCurrentFilterValues();
      return filterValues.onlyMy
    }
  };

  return (
    <>
      <div className={styles.containerList}>
        <div className={styles.header}>
          <PageHeader title={currentScreen.title} />
          <div className={styles.filter}>
            
            <div className={`${styles.clear} ${open ? styles['fade-in'] : ''}`} onClick={handleClearAll}>Clear all</div>
            
            <div
              className={`${styles.filterBtn} ${open ? styles['filterBtn_open'] : ''}`}
              onClick={() => setOpen(!open)}
            >
              <FilterIcon stroke={open ? "#9F9F9F" : "#3F3F40"} />
              Filters 
            </div>
          </div>
        </div>
        {currentScreen.screen === "List" && (
          <>
            <Filter
              open={open}
              socket={socket}
              ref={filterRef}
            />
          </>
        )}
        <RfqTable loading={loading} data={data} handleUseFilters={handleUseFilters}/>
      </div>
    </>
  );
};

export default DashboardList;
